export const ACTION_COLORS = {
    "Bloqueio de Acesso": "danger",
    "Impersonate (Login)": "warning",
    "Pagamento Manual": "success",
    "Criação de Cliente": "accent",
    "Plano Alterado": "info",
    "Liberação Provisória": "secondary",
};

export const ACTION_FILTER_OPTIONS = [
    { label: "Todas as Ações", value: "all" },
    { label: "Plano Alterado", value: "Plano Alterado" },
    { label: "Acesso como Cliente", value: "Impersonate (Login)" },
    { label: "Pagamento Manual", value: "Pagamento Manual" },
    { label: "Liberação Provisória", value: "Liberação Provisória" },
    { label: "Bloqueios", value: "Bloqueio de Acesso" },
    { label: "Criação de Academia", value: "Criação de Cliente" },
];
